import { render, staticRenderFns } from "./Closed.vue?vue&type=template&id=c21382c6&scoped=true&"
import script from "./Closed.vue?vue&type=script&lang=js&"
export * from "./Closed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c21382c6",
  null
  
)

export default component.exports